'use strict';

PendingUploadsController.$inject = [
  '$scope',
  'DeviceServices',
  'PersistentUploaderService',
];

export function PendingUploadsController($scope, DeviceServices, PersistentUploaderService) {

  $scope.retryUploads = retryUploads;

  if (DeviceServices.isWebView()) {
    PersistentUploaderService.bindToScope($scope, 'uploads');
  }


  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function retryUploads() {
    PersistentUploaderService.tryUploads();
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}



// WEBPACK FOOTER //
// ./src/js/settings/controllers/PendingUploadsController.js